import React from 'react'
import styled from '../themes/styled'
import { TextScale as BaseTextScale } from '../styles/textScale'
import { SemanticColors } from '../colors'

export type TextCase = 'uppercase' | 'lowercase' | 'titleCase'
type Decoration = 'underline' | 'lineThrough' | 'overline'
type TextAs = 'span' | 'div' | 'label'
type TextAlign = 'left' | 'right' | 'center' | 'justify'
type TextDisplay = 'block' | 'inline'
type TextCursor = 'auto' | 'pointer'
export type TextColor = keyof SemanticColors['text']
export type IndicatorColor = keyof SemanticColors['indicator']
export type TextScale = keyof BaseTextScale

export interface TextProps extends React.HTMLProps<HTMLDivElement> {
    scale?: TextScale
    case?: TextCase
    decoration?: Decoration
    as?: TextAs
    color?: TextColor | IndicatorColor
    textAlign?: TextAlign
    textDisplay?: TextDisplay
    textCursor?: TextCursor
}

const TextContainer = styled.div<TextProps>(props => ({
    ...props?.theme?.textScale?.[props.scale ?? 'bodyS400'],
    color:
        props?.theme?.colors?.text?.[props.color as TextColor] ??
        props?.theme?.colors?.indicator?.[props.color as IndicatorColor] ??
        props?.theme?.colors?.text?.primary,
    height: 'fit-content',
    width: 'fit-content',
    textDecoration: props.decoration === 'lineThrough' ? 'line-through' : props.decoration,
    textTransform: props.case === 'titleCase' ? 'capitalize' : props.case,
    display: props.textDisplay ? props.textDisplay : 'block',
    cursor: props.textCursor ? props.textCursor : 'auto',
    whiteSpace: 'pre-line',
}))

const Text = React.forwardRef<HTMLDivElement, TextProps>(({ as = 'div', children, ...rest }, ref) => {
    return (
        <TextContainer as={as} {...rest} ref={ref}>
            {children}
        </TextContainer>
    )
})

// Set displayName property on the component.
// The fixes the "Component definition is missing display name" error
Text.displayName = 'Text'

export default Text
